module.exports = __webpack_public_path__ + "img/sar.7de640b7.png";